import { FeeLine } from "@/offering/api";
import { toFeeLine } from "@/offering/hooks/use_quote_query";
import useSWR from "swr";

export interface MembershipCharge {
  id: string;
  currency: string;
  transactionType: "charge" | "refund";
  paymentDate: string;
  refundedAmount: number | null;
  taxAmount: number;
  taxDescription: string | null;
  promotionAmount: number;
  promotionDescription: string | null;
  promotionCode: string | null;
  totalPrice: number;
  subTotalBeforeDiscount: number;
  adjustmentAmount: number;
  unitPrice: number;
  paymentCycles: number;
  cardImageUrl: string;
  cardEnding: string;
  cardBrand: string;
  isFirstCharge: boolean;
  membershipPlan: {
    name: string;
    location: string;
  };
  feeLines?: FeeLine[];
}

type MembershipCharges = MembershipCharge[];

interface UseMembershipChargesQueryReturn {
  data: MembershipCharges | undefined;
}

export function useMembershipChargesQuery(
  partnerId: string,
  subscriptionId: string
): UseMembershipChargesQueryReturn {
  const { data } = useSWR(
    `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/charges`
  );

  return { data: toUpcomingPayment(data?.data) };
}

function toUpcomingPayment(data?: any): MembershipCharges | undefined {
  try {
    if (data) {
      return data.map(
        (charge: any): MembershipCharge => ({
          id: charge.id,
          currency: charge.currency,
          transactionType: charge.transaction_type,
          paymentDate: charge.payment_date,
          taxAmount: charge.tax_amount,
          refundedAmount: charge.refunded_amount,
          taxDescription: charge.tax_description,
          promotionAmount: charge.promotion_amount,
          promotionCode: charge.promotion_code,
          promotionDescription: charge.promotion_description,
          totalPrice: charge.total_price,
          subTotalBeforeDiscount: charge.sub_total_before_discount,
          adjustmentAmount: charge.adjustment_amount,
          unitPrice: charge.unit_price,
          paymentCycles: charge.payment_cycles,
          cardEnding: charge.card_ending,
          cardImageUrl: charge.card_image_url,
          cardBrand: charge.card_brand,
          isFirstCharge: charge.is_first_charge,
          membershipPlan: {
            name: charge.membership_plan.name,
            location: charge.membership_plan.location,
          },
          feeLines: charge.fee_lines?.map(toFeeLine),
        })
      );
    }
  } catch {
    throw new Error("Error mapping data");
  }
}
